// extracted by mini-css-extract-plugin
export default {"sendForm":"MessageSender_sendForm__A6QRt","textarea":"MessageSender_textarea__hvhfx","button":"MessageSender_button__yiNM6"};